<template>
    <div class="w-full overflow-hidden">
        <!-- 步驟 -->
        <ul class="flex justify-between max-w-4xl md:mx-auto mt-2 -ml-4  md:mt-5 w-[calc(100%+2rem)] md:w-full">
            <li
                v-for="(item, index) in steps"
                :key="index"
                class="flex-1 relative"
            >
                <div class="w-full relative h-8">
                    <!-- 線 -->
                    <div
                        :class="[index+1 < steps.length? 'w-full': 'w-0']"
                        class=" absolute h-1 bg-gray-50 md:bg-gray-75 ml-[calc(50%-12px)] md:ml-[calc(50%-15px)] top-[0.625rem] md:top-[0.9375rem]"
                    />
                    <transition name="fade">
                        <div
                            v-if="nowStep>index+1"
                            :class="[index+1 < steps.length? 'w-full': 'w-0']"
                            class="absolute h-1 bg-primary ml-[calc(50%-12px)] md:ml-[calc(50%-15px)] top-[0.625rem] md:top-[0.9375rem]"
                        />
                    </transition>
                    <!-- 圈 -->
                    <div class="absolute w-full">
                        <div
                            :class="[nowStep>index? 'bg-primary md:border-white text-white':'bg-white md:border-gray-75 text-gray-100']"
                            class="rounded-full mx-auto border-gray-50 text-sm w-[1.5625rem] h-[1.5625rem] md:w-[1.875rem] md:h-[1.875rem] flex items-center justify-center border-2"
                        >
                            <transition name="bounce">
                                <span v-if="index+1 >= nowStep && nowStep !==steps.length">
                                    {{ index+1 }}
                                </span>
                                <!-- 最後一個步驟icon是圓圈 -->
                                <svg
                                    v-else-if="index+1 ===steps.length"
                                    class="h-6 w-6"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                                    />
                                </svg>
                                <!-- 其他步驟icon是勾 -->
                                <svg
                                    v-else
                                    class="h-4 w-4"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
                                    />
                                </svg>
                            </transition>
                        </div>
                    </div>
                </div>
                <!-- 字 -->
                <p
                    v-if="index+1 === nowStep"
                    class="text-sm text-primary text-center hidden md:block tracking-wide leading-none mb-2"
                >
                    {{ item.text }}
                </p>
            </li>
        </ul>
    </div>
</template>
<script>
import { ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import aplCatlCode from '@/json/aplCatlCode';
import routeName from '@/router/constant.js';

export default {
    name: 'Steps',
    setup() {
        const route = useRoute();
        const store = useStore();
        const nowStep = ref(0);
        const steps = ref([]);
        const aplCatl = computed(() => store.state.services.aplCatl);

        const step4 = [
            {
                text: '輸入變更內容',
                routeName: '',
            },
            {
                text: '確認變更資料',
                routeName: routeName.CONFIRM_DATA,
            },
            {
                text: '輸入動態密碼',
                routeName: routeName.OTP,
            },
            {
                text: '委託受理結果',
                routeName: routeName.FINISH,
            },
        ];
        if (aplCatl.value === aplCatlCode.PON4300) {
            step4[0].text = '輸入借款內容';
            step4[1].text = '確認借款內容';
        }
        const step5 = JSON.parse(JSON.stringify(step4));
        const refundPayStep = {
            text: '補/退費方式',
            routeName: routeName.REFUND_PAYMENT,
        };
        step5.splice(2, 0, refundPayStep);
        steps.value = step4;
        watch([() => route.name, () => store.state.services.transactionItems], ([newVal1]) => {
            const transactionItems = store.state.services.transactionItems;
            const list = transactionItems ? transactionItems.filter(i => i.userChecked) : [];
            if (list.length > 0) {
                const hasRefundPayment = list.find(i => i.needRefund || i.needSupplement);
                steps.value = hasRefundPayment ? step5 : step4;
            }
            if (route.meta.code || newVal1 === routeName.RISK_NOTICE) {
                nowStep.value = 1;
            } else {
                const index = steps.value.findIndex(i => i.routeName === newVal1);
                nowStep.value = index + 1;
            }
        }, { immediate: true, deep: true });
        return {
            steps,
            nowStep,
        };
    }
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.bounce-enter-active {
    animation: bounce-in 0.5s;
}
.bounce-leave-active {
    animation: bounce-in 0.05s reverse;
}
@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.5);
    }
    100% {
        transform: scale(1);
    }
}
</style>
